var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .icon-person{\n    fill:none;\n  }\n  .icon-person .c{\n    stroke-width:0.8;\n    stroke:#646464;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-person"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.6L15.6 14.1C15.4 13.4 14.9 12.8 14.2 12.6L11.4 11.7C10.8 11.4 10.5 10.3 10.4 9.9 10.9 9.5 11.2 8.9 11.3 8.2 11.3 8.1 11.3 8 11.4 7.9 11.5 7.8 11.6 7.8 11.6 7.7 11.8 7.3 11.9 6.8 11.9 6.3 11.9 6.3 11.9 6.3 11.9 6.2 11.9 6.1 11.8 5.9 11.6 5.8L11.6 4.1C11.6 3.1 11.3 2.7 11 2.5 10.9 2 10.4 1 8.5 1 6.8 1.1 5.4 2.4 5.4 4.1L5.4 5.8C5.2 5.9 5.1 6.1 5.1 6.2 5.1 6.3 5.1 6.3 5.1 6.3 5.1 6.8 5.2 7.3 5.4 7.7 5.4 7.8 5.5 7.8 5.6 7.9 5.6 7.9 5.7 8 5.7 8.2 5.8 8.9 6.1 9.5 6.6 9.9 6.5 10.3 6.2 11.4 5.6 11.7L2.8 12.6C2.1 12.8 1.6 13.4 1.4 14.1L1 15.6C1 16.5 3.3 17 8.2 17 13.2 17 16 16.6 16 15.6Z",
    className: "undefined"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonalInfo);
export default __webpack_public_path__ + "static/media/icPersonalInfo.196054f87267c2663d7d9918b9a99c34.svg";
export { ForwardRef as ReactComponent };